var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcWindows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1164 0 0 1.1164 -29.791 -29.847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m202.1 266.7h-108.7c-7.4 0-13.4 6.1-13.4 13.7v89c0 6.6 4.6 11.9 10.7 13.2l105.4 21.1 6.9 1.2c7-0.3 12.7-6.4 12.7-13.5v-111c0-7.7-6.2-13.7-13.6-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.4 266.7h-168.2c-7.4 0-13.4 6.1-13.4 13.7v120.7c0 5.5 3.3 10.1 7.9 12.2l0.2 0.2 5.3 1.1h0.3l164.7 32.9c0.2 0.1 0.5 0.3 0.7 0.3 0.1 0 0.2 0 0.3-0.1 0.7 0.4 1.4 0.4 2.1 0.4 7.4 0 13.6-6 13.6-13.5v-154.2c0.1-7.7-6.1-13.7-13.5-13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.4 64c-0.7 0-1.4 0-2.1 0.4-0.1-0.1-0.2-0.1-0.3-0.1-0.2 0-0.5 0.1-0.7 0.3l-164.8 32.8h-0.3l-5.1 1.1s-0.2 0-0.4 0.2c-4.6 2.1-7.9 6.9-7.9 12.4v120.5c0 7.6 6 13.7 13.4 13.7h168.2c7.4 0 13.6-6.1 13.6-13.7v-154.1c0-7.4-6.2-13.5-13.6-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203 107-6.9 1.2-105.4 21.2c-6.1 1.3-10.7 6.6-10.7 13.2v89c0 7.6 6 13.7 13.4 13.7h108.8c7.4 0 13.6-6.1 13.6-13.7v-111.1c-0.1-7.1-5.7-13.1-12.8-13.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWindows);
export default __webpack_public_path__ + "static/media/ic_windows.99aba39d.svg";
export { ForwardRef as ReactComponent };